import { createLitComponent } from "../lib/create-lit-component.js";
import { GivebutterHTMLRenderer } from "@givebutter/widgets-core";
//#region src/components/GivebutterHtmlRenderer.tsx
const GivebutterHtmlRenderer = createLitComponent({
	elementClass: GivebutterHTMLRenderer,
	tagName: "givebutter-html-renderer"
});
//#endregion
export { GivebutterHtmlRenderer };
